import { render, staticRenderFns } from "./WorkorderPaymentHistory.vue?vue&type=template&id=56113f7b"
import script from "./WorkorderPaymentHistory.vue?vue&type=script&lang=js"
export * from "./WorkorderPaymentHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports